import { themedStyled } from 'common/styles/styletron.theme';

export const CardContainer = themedStyled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
});

export const HalfContainer = themedStyled('div', ({ $theme }) => ({
  width: '100%',
  [`${$theme.mediaQuery.md}`]: {
    width: '48%',
  },
}));

export const DocumentContainer = themedStyled('div', {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
});
